export default __webpack_public_path__ + "static/media/token-metrics-1.41fecedb.svg";